import { el } from "redom";

export default class Error {
  constructor({ i18n, api }) {
    this.content = el(".error-text");
    this.ok = el("button.button", i18n("ok"));

    this.el = el(
      ".error",
      el(".error-bg"),
      el(".error-content", this.content, el(".buttons", this.ok))
    );

    this.el.onclick = () => {
      api.error = null;
      api.update();
    };
  }
  update(data) {
    const { error } = data;

    this.content.innerHTML = error;
  }
}
